<template>
  <modal-default
      ref="modal"
      :title="title"
      :width="width"
      :short-circuit-close="true"
      @close="cancel"
  >
    <div class="content">
      <p>Please choose a date below.</p>
    </div>

    <form-field-datetime-picker
        v-model="date"
        is-inline
    ></form-field-datetime-picker>

    <div v-if="nextAppointment || nextTask" class="mt-50">
      <div class="content">
        <p>Or use either the next appointment or scheduled contact time below:</p>
      </div>

      <div v-if="nextAppointment" class="use-time-line">
        <strong>Next Appointment:</strong> {{ nextAppointment }}
        <b-button
          type="is-primary"
          size="is-small"
          outlined
          @click="setTimeToThis(nextAppointment)"
        >Use</b-button>
      </div>

      <div v-if="nextTask" class="use-time-line">
        <strong>Next Scheduled Contact:</strong> {{ nextTask }}
        <b-button
          type="is-primary"
          size="is-small"
          outlined
          @click="setTimeToThis(nextTask)"
        >Use</b-button>
      </div>
    </div>

    <template v-slot:footer>
      <button-default @click="cancel">Cancel</button-default>
      <button-default @click="confirmed">Confirm</button-default>
    </template>
  </modal-default>
</template>

<script>

import ModalBase from "./ModalBase";
import {destroyModal} from "../../services/modals";
import dates from "../../services/dates";
export default {
  name: "PromptDateModal",
  components: {ModalBase},
  props: {
    title: {
      type: String,
      default: 'Select A Date'
    },
    width: {
      type: Number,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      date: dates.getNowISO(),
    }
  },
  mounted() {
    this.$refs.modal.open();
  },
  computed: {
    record() {
      // follow up pipeline
      if (this.$store.getters['activeFollowUpStateItem/recordId']) {
        return { id: this.$store.getters['activeFollowUpStateItem/recordId'] };
      }

      // inbox new leads tab
      if (this.$store.getters['activeInboxLeadItem/recordId']) {
        return this.$store.getters['activeInboxLeadItem/record']
      }

      // inbox responses tab
      if (this.$store.getters['activeInboxInboundCommItem/contactId']) {
        return this.$store.getters['activeInboxInboundCommItem/record'];
      }

      // lead modal view
      if (this.$store.state.activeRecord) {
        return this.$store.state.activeRecord.record;
      }

      return { id: null };
    },
    nextTask() {
      const tasks = this.$store.getters.pipelineIncompleteTasks.filter(a => a.record_id === this.record.id)
        .sort((a,b) => new Date(a.due_at) - new Date(b.due_at));

      if (tasks.length) {
        return dates.formatAsDate(tasks[0].due_at);
      }

      return null;
    },
    nextAppointment() {
      const appointments = this.$store.getters.pipelineAppointments.filter(a => a.record_id === this.record.id)
        .sort((a,b) => new Date(a.start_at) - new Date(b.start_at));

      if (appointments.length) {
        return dates.formatAsDate(appointments[0].start_at);
      }

      return null;
    },
  },
  methods: {
    confirmed() {
      this.$emit('confirmed', this.date);
      destroyModal(this.$refs.modal);
    },
    cancel() {
      this.$emit('canceled');
      destroyModal(this.$refs.modal);
    },
    setTimeToThis(date) {
      this.$emit('confirmed', date);
      destroyModal(this.$refs.modal);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.use-time-line {
  @include clearfix;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid $border;
  line-height: 27px;

  &:last-child {
    border-bottom: none;
  }

  button {
    float: right;
  }
}
</style>
